import { Paper, Typography, Box, Avatar, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface ResearchCardType {
  title: string;
  description: string;
  link?: string;
  image: string;
  author: {
    name: string;
  };
  isPdf: boolean;
  onPDFClick: () => void;
}

const ResearchCard: React.FC<ResearchCardType> = ({
  title,
  description,
  link,
  image,
  author,
  isPdf,
  onPDFClick,
}) => {
  const navigate = useNavigate();
  return (
    <Paper
      elevation={0}
      sx={{
        width: "400px",
        borderRadius: "6px",
        marginBottom: "8px",
      }}
    >
      <img
        src={image}
        style={{
          width: "100%",
          height: "200px",
          objectFit: "cover",
          display: "block",
          borderRadius: "6px 6px 0 0",
        }}
        aria-label="card-image"
      />

      <Box
        sx={{
          padding: "24px",
          textWrap: "wrap",
          display: "flex",
          flexDirection: "column",
          height: "350px",
          alignItems: "flex-start",
        }}
      >
        <Typography variant="h5">{title}</Typography>

        <Box
          sx={{
            flexGrow: 1,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              marginTop: "12px",
            }}
          >
            {description}
          </Typography>
        </Box>

        <Button
          variant="text"
          color="secondary"
          sx={{
            marginTop: "12px",
          }}
          onClick={() => {
            if (!isPdf) {
              navigate(link!);
            } else {
              onPDFClick();
            }
          }}
        >
          {isPdf ? "Read the Paper" : "Learn More"}
        </Button>

        <Box
          sx={{
            display: "flex",
            marginTop: "24px",
            alignItems: "center",
          }}
        >
          <Avatar />

          <Typography
            sx={{
              marginLeft: "12px",
              fontSize: "18px",
              fontWeight: 400,
              fontStyle: "italic",
            }}
          >
            {author.name}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ResearchCard;
